import { PROJECT_INFO, REFERENCES } from '../data/mockData';
import { Sigma, Mail, MapPin } from 'lucide-react';

// 区块10：页脚
export default function Section10Footer() {
  return (
    <footer id="footer" className="relative w-full bg-deepBlue border-t border-gold/10 py-16 px-8">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-12">
          {/* 项目信息 */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <Sigma className="w-10 h-10 text-gold" />
              <h3 className="text-3xl font-bold text-white">数师有方</h3>
            </div>
            <p className="text-lg text-slate-300 leading-relaxed mb-6">
              {PROJECT_INFO.fullName}
            </p>
            <div className="space-y-3 text-slate-400">
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-cyan" />
                <span>{PROJECT_INFO.school} · {PROJECT_INFO.colleges}</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-cyan" />
                <span>指导教师：{PROJECT_INFO.teachers.join(' · ')}</span>
              </div>
            </div>
          </div>

          {/* 项目数据速览 */}
          <div>
            <h4 className="text-xl font-bold text-gold mb-6">项目速览</h4>
            <ul className="space-y-3 text-slate-300">
              <li className="flex justify-between border-b border-white/10 pb-2">
                <span>团队规模</span>
                <span className="text-white font-bold">{PROJECT_INFO.teamSize}人</span>
              </li>
              <li className="flex justify-between border-b border-white/10 pb-2">
                <span>年级</span>
                <span className="text-white font-bold">{PROJECT_INFO.grade}</span>
              </li>
              <li className="flex justify-between border-b border-white/10 pb-2">
                <span>项目时间节点</span>
                <span className="text-white font-bold">{PROJECT_INFO.date}</span>
              </li>
              <li className="flex justify-between border-b border-white/10 pb-2">
                <span>数据标注</span>
                <span className="text-white font-bold">基于模拟数据/行业公开报告推算</span>
              </li>
            </ul>
          </div>

          {/* 参考文献 */}
          <div>
            <h4 className="text-xl font-bold text-gold mb-6">参考文献</h4>
            <ol className="space-y-2 text-sm text-slate-400 list-decimal list-inside">
              {REFERENCES.map((ref, index) => (
                <li key={index} className="leading-relaxed">{ref}</li>
              ))}
            </ol>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="text-center pt-8 border-t border-white/10">
          <p className="text-slate-500 text-base">
            © {PROJECT_INFO.date} 数师有方团队 · {PROJECT_INFO.school}数学与统计学学院 · 互联网+大赛路演展示
          </p>
        </div>
      </div>
    </footer>
  );
}
